import React from "react";

const RadiusSelector = ({ radius, setRadius }) => {
	const radiusOptions = [1, 5, 10, 20, 30];

	return (
		<div className="radius-box m-3 p-3">
			<div className="d-flex justify-content-between">
				<h6>Distance Radius</h6>
				<span>{radius} km</span>
			</div>
			<div className="scroll-row d-flex gap-2 mt-2">
				{radiusOptions.map((km) => (
					<div
						key={km}
						className={`distance-pill  mr-2 ${radius === km ? "active-distance" : ""}`}
						onClick={() => setRadius(km)}
					>
						{km}km
					</div>
				))}
			</div>
		</div>
	);
};

export default RadiusSelector;
